import { FC, Props } from "./typings";
import ClassificationDefaultStatus from "../ClassificationDefaultStatus";

const ClassificationClientsStatus: FC<Props> = ({ myPrivilages, type }) => {
  return (
    <ClassificationDefaultStatus myPrivilages={myPrivilages} type={type} />
  );
};

export default ClassificationClientsStatus;
